import React, { useState } from 'react';
import styles from './Invoices.module.css';
import { FiEdit2 } from 'react-icons/fi';
import { useDispatch } from 'react-redux';
import { openModal } from '../../redux/slices/modalSlice';
import ResultAndCount from '../../components/ResultAndCount/ResultAndCount';
import Dropdown from '../../components/Dropdown/Dropdown';
import SearchBar from '../../components/SearchBar/SearchBar';
import PaginationTable from '../../components/PaginationTable/PaginationTable';
import DynamicTable from '../../components/DynamicTable/DynamicTable';
import LogoWithName from '../../components/LogoWithName/LogoWithName';
import IconAndName from '../../components/IconAndName/IconAndName';
import { MdOutlineTextSnippet } from 'react-icons/md';
import CopyRight from '../../components/CopyRight/CopyRight';
import { IoMdTrash } from 'react-icons/io';
import { useNavigate } from 'react-router-dom';
import Action from '../../components/Action/Action';

const data = [
  {
    _id: 'inv1',
    studentName: 'John Jacob',
    invoiceId: 'ID763782',
    dueDate: '2025-06-03',
    invoicedAmount: 2600,
    paidAmount: 3600,
    pendingAmount: 2400,
  },
  {
    _id: 'inv2',
    studentName: 'John Jacob',
    invoiceId: null,
    dueDate: null,
    invoicedAmount: null,
    paidAmount: null,
    pendingAmount: null,
  },
  {
    _id: 'inv3',
    studentName: 'John Jacob',
    invoiceId: 'ID763782',
    dueDate: '2025-06-03',
    invoicedAmount: 2600,
    paidAmount: 3600,
    pendingAmount: 2400,
  },
  {
    _id: 'inv4',
    studentName: 'John Jacob',
    invoiceId: null,
    dueDate: null,
    invoicedAmount: null,
    paidAmount: null,
    pendingAmount: null,
  },
];

const Invoices = () => {
  const dispatch = useDispatch();
  const [count, setCount] = useState(7);
  const [search, setSearch] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(5);
  const [selectedIds, setSelectedIds] = useState([]);

  const totalIssued = data.reduce((sum, d) => sum + (d.depositIssued || 0), 0);
  const totalUsed = data.reduce((sum, d) => sum + (d.depositUsed || 0), 0);
  const totalRefunded = data.reduce(
    (sum, d) => sum + (d.depositRefunded || 0),
    0
  );
  const totalBalance = data.reduce(
    (sum, d) => sum + (d.depositBalance || 0),
    0
  );
  const navigate = useNavigate();

  const handlecreateform = () => {
    dispatch(openModal('accountingInvoice'));
  };
  const handleEditClick = () => {
    dispatch(openModal('chooseRange'));
  };
  const handleArchiveClick = () => {
    navigate('/deposithistory');
  };
  const totalInvoiced = data.reduce(
    (sum, s) => sum + (s.invoicedAmount || 0),
    0
  );
  const totalPaid = data.reduce((sum, s) => sum + (s.paidAmount || 0), 0);
  const totalPending = data.reduce((sum, s) => sum + (s.pendingAmount || 0), 0);

  const headingsData = [
    {
      title: (
        <input
          type="checkbox"
          checked={selectedIds.length === data.length}
          onChange={(e) => {
            const checked = e.target.checked;
            setSelectedIds(checked ? data.map((d) => d._id) : []);
          }}
        />
      ),
      accessor: 'checkBox',
    },
    { title: 'Student Name', accessor: 'studentName' },
    { title: 'Invoice ID', accessor: 'invoiceId' },
    { title: 'Due Date', accessor: 'dueDate' },
    { title: 'Invoiced Amount', accessor: 'invoicedAmount' },
    { title: 'Paid Amount', accessor: 'paidAmount' },
    { title: 'Pending Amount', accessor: 'pendingAmount' },
    { title: 'Action', accessor: 'action' },
  ];

  const getColumnData = (data) => {
    return data.map((item) => {
      const isChecked = selectedIds.includes(item._id);
      return {
        checkBox: (
          <input
            type="checkbox"
            checked={isChecked}
            onChange={(e) => {
              const checked = e.target.checked;
              if (checked) {
                setSelectedIds((prev) => [...prev, item._id]);
              } else {
                setSelectedIds((prev) => prev.filter((id) => id !== item._id));
              }
            }}
          />
        ),
        studentName: <LogoWithName name={item.studentName || '-'} />,
        invoiceId: item.invoiceId || '-',
        dueDate: item.dueDate
          ? new Date(item.dueDate).toLocaleDateString('en-GB')
          : '-',
        invoicedAmount:
          item.invoicedAmount != null ? `INR ${item.invoicedAmount}` : '-',
        paidAmount: item.paidAmount != null ? `INR ${item.paidAmount}` : '-',
        pendingAmount:
          item.pendingAmount != null ? `INR ${item.pendingAmount}` : '-',
        action: (
          <Action
            options={['Edit', 'Delete']}
            onSelect={(opt) => {
              if (opt === 'Edit') dispatch(openModal('editDetails'));
              if (opt === 'Delete') dispatch(openModal('delete'));
            }}
          />
        ),
      };
    });
  };

  const displayData = getColumnData(data);

  return (
    <>
      <div className={styles.mainContainer}>
        <div className={styles.container}>
          <div className={styles.createForm}>
            <button className={styles.archiveBtn} onClick={handleArchiveClick}>
              Not Conformed this row buttons//Will change later
            </button>
            <Dropdown
              label="Invoice Date"
              options={['Annual Day', 'Freshers']}
              bgColor="rgba(from var(--Utility_Color1) r g b / 1)"
            />
            <Dropdown
              label="Send Remainder"
              options={['Annual Day', 'Freshers']}
              bgColor="rgba(from var(--Utility_Color1) r g b / 1)"
            />
            <IconAndName
              icon={<MdOutlineTextSnippet />}
              title="Create Invoice"
              bgColor="Primary_Color"
              onClick={handlecreateform}
            />
          </div>
          {/* 🟩 Result Cards + This Month */}
          <div className={styles.rowWrapper}>
            <div className={styles.cardsWrapper}>
              <ResultAndCount
                label="Billed Amount"
                count={` ${totalIssued}/-`}
                bgColor="rgba(from var(--Success_Color) r g b / 0.4)"
                textColor="Black_Color"
              />
              <ResultAndCount
                label="Collected Amount"
                count={` ${totalUsed}/-`}
                bgColor="rgba(from var(--Primary_Color) r g b / 0.35)"
                textColor="Black_Color"
              />
              <ResultAndCount
                label="Due Amount"
                count={` ${totalRefunded}/-`}
                bgColor="rgba(from var(--Warning_Color) r g b / 0.3)"
                textColor="Black_Color"
              />
              <ResultAndCount
                label="OutStanding Amount"
                count={` ${totalBalance}/-`}
                bgColor="rgba(from var(--Error_Color) r g b / 0.4)"
                textColor="Black_Color"
              />
            </div>

            <div className={styles.editWrapper} onClick={handleEditClick}>
              <FiEdit2 size={16} />
              <span>This Month</span>
            </div>
          </div>

          {/* 🔍 Search & Filters Row */}
          <div className={styles.totalstudentcard}>
            <div className={styles.studentsection}>
              <div className={styles.search}>
                <SearchBar
                  placeholder="Search Student"
                  onChange={(e) => console.log(e.target.value)}
                />
              </div>
              <div className={styles.filters}>
                <Dropdown
                  label="Student Status"
                  options={['Annual Day', 'Freshers']}
                  bgColor="rgba(from var(--Utility_Color1) r g b / 1)"
                />
                <Dropdown
                  label="Program"
                  options={['Annual Day', 'Freshers']}
                  bgColor="rgba(from var(--Utility_Color1) r g b / 1)"
                />
                <Dropdown
                  label="Group"
                  options={['Group 1', 'Group 2']}
                  bgColor="rgba(from var(--Utility_Color1) r g b / 1)"
                />
                <Dropdown
                  label="Room"
                  options={['Room1', 'Room2']}
                  bgColor="rgba(from var(--Utility_Color1) r g b / 1)"
                />
                <IoMdTrash
                  size={26}
                  style={{
                    marginTop: '0.5rem',

                    opacity: 0.4,
                    color: 'var(--Black_Color)',
                    cursor: 'pointer',
                  }}
                  onClick={() => {
                    dispatch(openModal('delete'));
                  }}
                />
              </div>
            </div>

            {/* Student Data Table */}
            <div className={styles.dynamicdata}>
              <DynamicTable
                headings={headingsData}
                columnData={displayData.slice(
                  (currentPage - 1) * itemsPerPage,
                  currentPage * itemsPerPage
                )}
              />
            </div>
            <div className={styles.paginationTable}>
              <PaginationTable
                data={displayData}
                currentPage={currentPage}
                itemsPerPage={itemsPerPage}
                setCurrentPage={setCurrentPage}
                setItemsPerPage={setItemsPerPage}
              />
            </div>
          </div>
        </div>
      </div>
      <CopyRight />
    </>
  );
};

export default Invoices;
